// SAMPLE:
// {
//     "progressSummary": {
//         "totalMissions": 0,
//         "completedMissions": 0,
//         "inProgressMissions": 0,
//         "lockedMissions": 0,
//         "totalRewardsEarned": 0,
//         "completionPercentage": 0
//     },
//     "_id": "6936d6f756d514386784a599",
//     "userId": "674d37392c391f1235829b47",
//     "missionPlanId": {
//         "_id": "692e561e1ab98ec19a02f1ca",
//         "name": {
//             "en": "Hot Topic Sharing Challenge",
//             "zh": "熱門話題分享挑戰",
//             "zh-Hant-HK": "熱門話題分享挑戰"
//         },
//         "description": {
//             "en": "Share hot topics within one month to compete on the leaderboard and win rewards",
//             "zh": "一個月內分享熱門話題，在排行榜上競爭並贏取獎勵",
//             "zh-Hant-HK": "一個月內分享熱門話題，在排行榜上競爭並贏取獎勵"
//         },
//         "missions": [
//             {
//                 "contents": {
//                     "body": []
//                 },
//                 "title": {
//                     "en": "Hot Topic Sharing Ranking",
//                     "zh": "熱門話題分享排行榜",
//                     "zh-Hant-HK": "熱門話題分享排行榜"
//                 },
//                 "description": {
//                     "en": "Compete with others by sharing hot topics. The more you share, the higher your rank!",
//                     "zh": "通過分享熱門話題與他人競爭。分享越多，排名越高！",
//                     "zh-Hant-HK": "通過分享熱門話題與他人競爭。分享越多，排名越高！"
//                 },
//                 "category": "engagement",
//                 "difficulty": "medium",
//                 "estimatedMinutes": 10,
//                 "icon": "trophy",
//                 "tags": [
//                     "ranking",
//                     "leaderboard",
//                     "sharing",
//                     "competition"
//                 ],
//                 "requirements": [
//                     {
//                         "targetValue": 0,
//                         "targetField": "hot_topic_shared",
//                         "type": "ranking",
//                         "action": "hot_topic_shared",
//                         "operator": "ranking",
//                         "value": 1,
//                         "_id": "692e561e1ab98ec19a02f1cc"
//                     }
//                 ],
//                 "rewards": [],
//                 "_id": "692e561e1ab98ec19a02f1cb",
//                 "createdAt": "2025-12-02T02:59:42.096Z",
//                 "updatedAt": "2025-12-02T02:59:42.096Z"
//             }
//         ],
//         "planType": "challenge",
//         "priority": 5
//     },
//     "enrolledVersion": "2025-12-02T02:59:42.095Z",
//     "missionPlanType": "challenge",
//     "centralizedMissions": true,
//     "status": "active",
//     "enrolledBy": "user",
//     "completedAt": null,
//     "executionTimeRange": {
//         "timeWindow": {
//             "startAt": 0,
//             "endAt": 86400000
//         },
//         "startAt": "2024-01-01T00:00:00.000Z",
//         "endAt": null,
//         "daysOfWeek": [],
//         "daysOfMonth": []
//     },
//     "createdAt": "2025-12-02T02:59:42.096Z",
//     "updatedAt": "2025-12-02T02:59:42.096Z",
//     "__v": 0,
//     "earnedRewards": []
// }

// This function is used to get the mission and event
// mapping from a single mission enrollment object
export const getMissionAndEventMapping = (enrollment = {}) => {

  // 1. GET REQUIREMENTS FROM MISSION
  //   {
  //     "targetValue": 0,
  //     "targetField": "hot_topic_shared",
  //     "type": "ranking",
  //     "action": "hot_topic_shared",
  //     "operator": "ranking",
  //     "value": 1,
  //     "_id": "692e561e1ab98ec19a02f1cc"
  // }

  // 2. map the requirements with the mission plan id, mission id and requirement id  :
  // Example:
  // {
  //     "hot_topic_shared": ["692e561e1ab98ec19a02f1ca.692e561e1ab98ec19a02f1cb.692e561e1ab98ec19a02f1cc"]
  // }

  const mapping = {};

  // Check if missionPlanId and missions exist
  if (!enrollment || !enrollment._id) {
    return mapping;
  }
  if (!enrollment.missionPlanId || !enrollment.missionPlanId?.missions || !enrollment.missionPlanId?.missions?.length) {
    return mapping;
  }

  const missionPlanId = enrollment.missionPlanId._id;
  const missions = enrollment.missionPlanId.missions;

  // Iterate through all missions
  missions.forEach(missionItem => {
    if (!missionItem.requirements || !missionItem._id) {
      return;
    }

    const missionId = missionItem._id;

    // Iterate through all requirements in the mission
    missionItem.requirements.forEach(requirement => {
      if (!requirement.action || !requirement._id) {
        return;
      }

      const action = requirement.action;
      const requirementId = requirement._id;
      // Contents IDs 
      const contentIds = requirement.contentIds;

      // Create the mapping string: missionPlanId.missionId.requirementId
      const mappingString = `${enrollment._id}.${missionPlanId}.${missionId}.${requirementId}`;

      // Initialize array if action doesn't exist in mapping
      
      if(contentIds && contentIds.length > 0 && !contentIds.includes('*')){
        contentIds.forEach(contentId => {
          const mappingKey = `${action}.${contentId}`;
          if (!mapping[mappingKey]) {
            mapping[mappingKey] = [];
          }
          mapping[mappingKey].push(mappingString);
        });
      }else{
        const mappingKey = action;
        if (!mapping[mappingKey]) {
          mapping[mappingKey] = [];
        }
        mapping[mappingKey].push(mappingString);
      }
    });
  });

  return mapping;
};
